/******************
// directive: animatedIntroductionText
*************/
angular.module('app')
        .directive('animatedIntroductionText', animatedIntroductionText);
animatedIntroductionText.$inject = [];
function animatedIntroductionText() {
    return {
        restrict: 'E',
        require: {
            scrollableContents: '^^scrollableContents',
            scrollableItem: '^^scrollableItem'
        },
        link: link
    }

    function link(scope, element, attrs, ctrl) {
        const container = angular.element(element);
        const smallText = container.find('.small-text');
        const largeText = container.find('.large-text');
        const xLargeText = container.find('.xlarge-text');
        const bottomText = container.find('.bottom-text');

        let tweenIntroduction = null;
        function animate() {
            //animation
            tweenIntroduction = new TimelineMax()
                .to(smallText, 0.75, { opacity: 1, ease: Sine.easeOut })
                .to(largeText, 0.75, { x: 0, opacity: 1, startAt: { x: -30 }, ease: Power4.easeInOut }, '-=0.5')
                .to(xLargeText, 0.75, { x: 0, startAt: { x: +30 }, opacity: 1, ease: Power4.easeInOut }, '-=0.5')
                .to(bottomText, 0.75, { y: 0, startAt: { y: +40 }, opacity: 1, ease: Expo.easeOut }, '-=0.75')
                .eventCallback('onComplete', function () {
                    if (parseInt(ctrl.scrollableItem.contentIndex) === parseInt(ctrl.scrollableContents.totalSections)) {
                        ctrl.scrollableContents.setArrowVisibility(false);
                        ctrl.scrollableContents.setFooterVisibility(true);
                    }
                    else {
                        ctrl.scrollableContents.setArrowVisibility(true);
                    }
                })
        }

        scope.$on('animate', function (event, args) {
            if (args.index === parseInt(ctrl.scrollableItem.contentIndex)) {
                if (tweenIntroduction !== null) {
                    tweenIntroduction.time(0).restart();
                }
                else {
                    animate();
                }
            }
        })

        scope.$on('pauseAnimation', function (event, args) {
            if (args.index === parseInt(ctrl.scrollableItem.contentIndex)) {
                if (tweenIntroduction) {
                    tweenIntroduction.pause();
                }
            }
        })
    }
}